import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/i18n';
import EcoImg from 'eco-design/base/eco-img';
import React from 'react';
import css from './index.module.scss';

interface Props {}

const J: React.FC<Props> = ({}) => {
    const { t } = useLang('theProduct.J');

    const { locale = 'us' } = getLocal();

    const imgObj = {
        us: {
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1762515004911-r95tet-compressed-Frame%201612707984.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1762515022214-mkwloa-compressed-Frame%201612707986.jpg',
        },
        de: {
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1772074271322-e7hmn5-compressed-Frame%201612708016.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1772074291162-2y2a0a-compressed-Frame%201612708017.jpg',
        },
        fr: {
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1772074309735-u4j1bt-compressed-Frame%201612708018.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1772074329877-ugzdcc-compressed-Frame%201612708019.jpg',
        },
        it: {
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1772074344892-zgt47m-compressed-Frame%201612708020.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1772074360255-thlklk-compressed-Frame%201612708021.jpg',
        },
        es: {
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1772074374086-o13vou-compressed-Frame%201612708022.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1772074387919-86ccyi-compressed-Frame%201612708023.jpg',
        },
    };

    return (
        <section
            id="rapid-mag-J"
            className={`rapid-mag-J ${css.section} GtmModuleData-section`}
            data-section-id={'rapid-mag-J'}
            data-section-title={t('title')}
        >
            <div className="info">
                <p className="title">{t('title')}</p>
                <p className="subtitle">{t('subtitle')}</p>
                <p className="desc">{t('desc')}</p>
                <div className="img">
                    <EcoImg pc={imgObj[locale]?.pc || imgObj.us.pc} pad={imgObj[locale]?.pc || imgObj.us.pc} h5={imgObj[locale]?.h5 || imgObj.us.h5} />
                </div>
            </div>
        </section>
    );
};
export default J;
